<div class="page-title-section row px-3 m-0 mb-3 pt-5 pb-4 flex-column">
  <div class="main-title main-theme-color d-flex justify-content-center text-uppercase text-center text-uppercase" [ngClass]="{'main-title-margin': !activityService?.ConfigSettings?.isMainBannerOn}" 
  (click)="filterByVenue = false">
    {{(displayByType === 'venue' ?     
    (filterByVenue ? selectedVenueName : 'allVenues') : (displayByType === 'dining' ? 'restaurants' : 'activities')) | translate}}</div>
  <div class="mt-3 sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">{{ activityService?.widgetSettings?.HeaderText  || (displayByType === 'activities' || displayByType === 'non_dining' ? 'spendYourDayWithAdventure' : 'chooseYourFineDine') | translate}}
  </div>
</div>

<ng-container *ngIf="!activityService.loaderRunning && (originalVenueList | checkAcceptReservations) == 0">
  <ng-container
    *ngTemplateOutlet="noDataTemplate;context:{contentMsg: 'notAcceptingReservations' , parameter : originalVenueList.length > 0 ? originalVenueList[0].PhoneNumber : ''}">
  </ng-container>
</ng-container>
<div *ngIf="(originalVenueList | checkAcceptReservations) != 0">
<div class="container inner-listing-area">
  <div *ngIf="!activityService.loaderRunning" class="d-flex flex-row justify-content-center align-items-center">
    <div matRipple matRippleCentered="true" *ngIf="nonDiningVenuesList?.length && (activityService.enableActivities || activityService.enableDining)"
    class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=false;filterNonDining()"
    [ngClass]="displayByType =='non_dining' ? 'sub-menu-selection' : 'sub-menu-unselected'">
    <div class="d-flex align-items-center"><mat-icon style="font-size: 21px;" [ngClass]="displayByType =='non_dining' ? 'mat-icon-color' : 'text-mat-icon-color'">stadium</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'reserveASpot' | translate}}</div>
    </div>
    <div matRipple matRippleCentered="true" *ngIf="activityService.enableActivities && (activityService.enableDining || nonDiningVenuesList?.length)"
      class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=true;displayByType='activities';"
      [ngClass]="displayByType =='activities' ? 'sub-menu-selection' : 'sub-menu-unselected'">
      <div class="d-flex align-items-center"><mat-icon [ngClass]="displayByType =='activities' ? 'mat-icon-color' : 'text-mat-icon-color'">filter_hdr</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'Activities' | translate}}</div>
    </div>
    <div matRipple matRippleCentered="true" *ngIf="activityService.enableDining && (activityService.enableActivities || nonDiningVenuesList?.length)"
      class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=false;filterDining()"
      [ngClass]="loadActivitiesOnly === false && displayByType =='dining' ? 'sub-menu-selection' : 'sub-menu-unselected'">
      <div class="d-flex align-items-center"><mat-icon style="font-size: 21px;" [ngClass]="!loadActivitiesOnly && displayByType =='dining' ? 'mat-icon-color' : 'text-mat-icon-color'">restaurant_menu</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'dining' | translate}}</div>
    </div>
  </div>
  <div class="row m-0 d-flex flex-wrap toggle-section justify-content-between align-items-center" *ngIf="!noDataFound">
    <div class="d-flex flex-wrap align-items-center">
      <div *ngIf="false" class="p-3">
        <mat-button-toggle-group #colorToggle="matButtonToggleGroup" class="text-uppercase"
          aria-label="Activities Venue Toggle" (change)="toggleActivitiesVenue($event)">
          <mat-button-toggle checked value="activities">{{'activities' | translate}}</mat-button-toggle>
          <mat-button-toggle value="venue">{{'venues' | translate}}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div *ngIf="activityService.ConfigSettings.filterDropDown" class="d-flex align-items-center">
        <mat-form-field appearance="outline">
          <mat-label>{{'filterByVenue' | translate}}</mat-label>
          <mat-select [(ngModel)]="filteredVenue">
            <mat-option [value]="'allActivities'" (click)="filterByVenue = false;displayByType='activities'">{{'allActivities' | translate}}
            </mat-option>
            <mat-option [value]="venue.RestaurantName" (click)="filterActivitiesByVenue(venue);displayByType='venue'"
              *ngFor="let venue of venueList;">{{venue.RestaurantName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="activity-view-toggle" (click)="filterByVenue = false;displayByType='activities';filteredVenue='allActivities';">close</mat-icon>
      </div>
      <div *ngIf="displayByType !=='non_dining' && (loadActivitiesOnly && (availableActivities.length > 0 || venueBasedActivityList.length > 0)) || (!loadActivitiesOnly && diningSpecialMeals.length > 0) && displayByType === 'activities'" class="p-3 d-flex flex-wrap align-items-center">
        <mat-form-field class="activity-date-filter" appearance="outline">
          <mat-label>{{'selectDateRange'| translate}}</mat-label>
          <mat-date-range-input [rangePicker]="picker" [min]="currentDateTime">
            <input readonly (dateChange)="updateDateFilterValue()" matStartDate placeholder="{{'startDate' | translate}}" [(ngModel)]="dateFilterStartDate">
            <input readonly (dateChange)="updateDateFilterValue()" matEndDate placeholder="{{'endDate' | translate}}" [(ngModel)]="dateFilterEndDate">
          </mat-date-range-input>
          <mat-icon class="date-picker-filter-clear-icon cursor" *ngIf="dateFilterStartDate || dateFilterEndDate" matDatepickerToggleIcon
                  (click)="dateFilterStartDate=null;dateFilterEndDate=null;updateDateFilterValue()">clear</mat-icon>
          <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="picker"></mat-datepicker-toggle>          
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        
        <mat-form-field class="activity-date-filter p-2" floatLabel="always" appearance="outline">
          <mat-label>{{'searchActivity' | translate}}</mat-label>
          <input matInput type="text" [(ngModel)]="searchText">
          <button *ngIf="searchText" matSuffix mat-icon-button aria-label="Clear" (click)="searchText=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        
      </div>
    </div>
    <div class="p-3 activity-view-toggle d-flex align-items-center" *ngIf="widgetConfigurations.ActivityViewType === 2">
      <mat-icon class="mat-icon-color" (click)="toggleView=1" [ngClass]="{'activity-view-toggle-active': toggleView === 1}">view_module</mat-icon>
      <mat-icon class="mat-icon-color" (click)="toggleView=0" [ngClass]="{'activity-view-toggle-active': toggleView === 0}">view_headline</mat-icon>
    </div>
  </div>
   
  <ng-container *ngIf="noDataFound">
    <div class="row m-0 p-3 d-flex flex-wrap toggle-section justify-content-between align-items-center">
    <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg: outOfServiceMessage || 'No Activities found!'}"></ng-container>
    </div>  
  </ng-container>
  <ng-container *ngIf="!noDataFound">
  <div class="row m-0 d-flex activities-selection"
    [ngClass]="{'flex-wrap': toggleView === 1, 'flex-column': toggleView === 0,'align-items-center': !toggleView && activityService.ConfigSettings.listLeftAlign === false}">
    <ng-container *ngIf="!activityService.loaderRunning && displayByType === 'activities'">
      <div [ngClass]="toggleView ? 'col-lg-4 col-md-6 p-3' : 'col-lg-6 col-md-9 col-12 p-3'" *ngFor="let avlLessons of availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText}">
        <ng-container *ngIf="toggleView">
          <ng-container *ngTemplateOutlet="actvitiesDisplayGridTemplate;context:{avlLessons:avlLessons}"></ng-container>
        </ng-container>
        <ng-container *ngIf="!toggleView">
          <ng-container *ngTemplateOutlet="actvitiesDisplayListTemplate;context:{avlLessons:avlLessons}"></ng-container>
        </ng-container>        
      </div>
      <div class="col-12 d-flex justify-content-center">
        <ng-container *ngIf="!availableActivities || (availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText}).length === 0">
          <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found'}"></ng-container>
        </ng-container>

      </div>
    </ng-container>

      <ng-container *ngIf="!activityService.loaderRunning && displayByType === 'venue'">
        <ng-container *ngIf="!filterByVenue">
          <ng-container *ngIf="toggleView">
            <div class="col-lg-4 col-md-6 p-3 venue-card" *ngFor="let venue of venueList; let venueIndex = index">
              <div class="activity d-flex flex-column" (click)="filterActivitiesByVenue(venue)">
                <div class="activity-image">
                  <img [src]="venue.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'" (error)="errorImageHandler($event)" />
                </div>
                <div class="activity-details col p-0 d-flex flex-column justify-content-between">
                  <div class="p-2 text-uppercase activity-title class-info__detail__location d-flex align-items-center">
                    <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                    &nbsp; {{venue.RestaurantName}}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!toggleView">
            <div class="col-md-6 col-12 p-3"
              *ngFor="let venue of venueList; let venueIndex = index">
              <div class="activity-venue-list d-flex flex-row align-items-center" (click)="filterActivitiesByVenue(venue)">
                <div *ngIf="activityService.ConfigSettings.showVenueImageInListView" class="activity-venue-list-image">
                  <img [src]="venue.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'" (error)="errorImageHandler($event)" />
                </div>
                <div class="activity-details col p-0 d-flex flex-column justify-content-between">
                  <div class="p-2 text-uppercase activity-title class-info__detail__location d-flex align-items-center">
                    <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                    {{venue.RestaurantName}}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!activityService.loaderRunning && (!venueList || venueList?.length === 0)">
            <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Venue found!'}"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="filterByVenue">
          <div *ngIf="widgetConfigurations.FilterByVenue" class="col-lg-12 col-md-12 p-3">
            <span class="back-to-venue" (click)="filterByVenue = false">
              <mat-icon matTooltip="{{'backToVenueListing'| translate}}">
                arrow_circle_left
              </mat-icon>
              <span class="venue-name main-theme-color">{{'allVenues'| translate}}</span>
            </span>
          </div>
          <div [ngClass]="toggleView ? 'col-lg-4 col-md-6 p-3' : 'col-lg-6 col-md-9 col-12 p-3'" *ngFor="let avlLessons of venueBasedActivityList | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate}">
            <ng-container *ngIf="toggleView">
              <ng-container *ngTemplateOutlet="actvitiesDisplayGridTemplate;context:{avlLessons:avlLessons}"></ng-container>
            </ng-container>
            <ng-container *ngIf="!toggleView">
              <ng-container *ngTemplateOutlet="actvitiesDisplayListTemplate;context:{avlLessons:avlLessons}"></ng-container>
            </ng-container>
          </div>
          <ng-container *ngIf="!venueBasedActivityList || (venueBasedActivityList | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate}).length === 0">
            <ng-container
              *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found'}">
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Dining Template -->
      <ng-container *ngIf="!activityService.loaderRunning && displayByType === 'dining'">
        <ng-container *ngFor="let dining of diningVenuesList; let venueIndex = index">
          <div *ngIf="toggleView" class="col-lg-4 col-md-6 p-3 dining-card">
            <div class="dining-inner-container d-flex flex-column">
              <div class="dining-image">
                <img [src]="dining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                  (error)="errorImageHandler($event)" />
              </div>
              <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                <div matTooltip="{{dining.RestaurantName | uppercase}}" matTooltipPosition="above"
                  class="p-2 text-uppercase text-center text-truncate dining-title">
                  {{dining.RestaurantName}}
                </div>
                <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                  (click)="clickReserveNow(dining)">{{'reserveNow' | translate}}</div>
              </div>
            </div>
          </div>
          <div *ngIf="!toggleView" class="col-lg-6 col-md-9 col-12 p-3">
            <div matTooltip="{{dining.RestaurantName | uppercase}}" matTooltipPosition="above"
              class="p-3 dining-list dining-list-title text-truncate text-uppercase text-center dining-title"
              (click)="clickReserveNow(dining)">
              {{dining.RestaurantName}}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!activityService.loaderRunning && (!diningVenuesList || diningVenuesList?.length === 0)">
          <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Dinings found'}"></ng-container>
        </ng-container>      
      </ng-container>    

      <!-- Non Dining Template -->
      <ng-container *ngIf="!activityService.loaderRunning && displayByType === 'non_dining'">
        <ng-container *ngFor="let nonDining of nonDiningVenuesList; let venueIndex = index">
          <div *ngIf="toggleView" class="col-lg-4 col-md-6 p-3 dining-card">
            <div class="dining-inner-container d-flex flex-column">
              <div class="dining-image">
                <img [src]="nonDining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                  (error)="errorImageHandler($event)" />
              </div>
              <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                <div matTooltip="{{nonDining.RestaurantName | uppercase}}" matTooltipPosition="above"
                  class="p-2 text-uppercase text-center text-truncate dining-title">
                  {{nonDining.RestaurantName}}
                </div>
                <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                  (click)="clickReserveNow_NonDining(nonDining)">
                  {{'reserveNow' | translate}}</div>
              </div>
            </div>
          </div>
          <div *ngIf="!toggleView" class="col-lg-6 col-md-9 col-12 p-3">
            <div matTooltip="{{nonDining.RestaurantName | uppercase}}" matTooltipPosition="above"
              class="p-3 dining-list dining-list-title text-truncate text-uppercase text-center dining-title"
              (click)="clickReserveNow_NonDining(nonDining)">
              {{nonDining.RestaurantName}}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!activityService.loaderRunning && (!nonDiningVenuesList || nonDiningVenuesList?.length === 0)">
          <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found!'}"></ng-container>
        </ng-container>      
      </ng-container>  

    </div>
    <ng-container *ngIf="!activityService.loaderRunning && showDiningSpecialMeals && displayByType === 'dining' && !loadActivitiesOnly">
      <div class="p-2 mx-3 mt-5 d-flex justify-content-center text-uppercase listing-sub-title">
        {{'specialMeals' | translate}}
      </div>
      <ng-container *ngIf="diningSpecialMeals.length > 0">
        <div class="d-flex"
          [ngClass]="{'flex-wrap': toggleView === 1, 'flex-column': toggleView === 0,'align-items-center': !toggleView && activityService.ConfigSettings.listLeftAlign === false}">
          <ng-container
            *ngFor="let specialMeal of diningSpecialMeals ; let venueIndex = index">
            <div *ngIf="toggleView" class="col-lg-4 col-md-6 p-3 special-meal-card">
              <div class="dining-inner-container d-flex flex-column">
                <!-- <div class="dining-image">
                            <img [src]="dining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                              (error)="errorImageHandler($event)" />
                          </div> -->
                <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                  <div matTooltip="{{specialMeal.LessonName | uppercase}}" matTooltipPosition="above"
                    class="p-2 text-uppercase text-center dining-title">
                    {{specialMeal.LessonName}}
                  </div>
                  <div
                    class="p-2 text-uppercase text-center class-info__detail__location d-flex justify-content-center align-items-center">
                    <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                    &nbsp;<span class="text-truncate activity-description-bold">{{specialMeal.venueName}}</span>
                  </div>
                  <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                    (click)="bookSpecialMeal(specialMeal)">{{'bookTable' | translate}}</div>
                </div>
              </div>
            </div>
            <div *ngIf="!toggleView" class="col-lg-6 col-md-9 col-12 p-3">
              <div class="p-1 dining-list d-flex flex-column" (click)="bookSpecialMeal(specialMeal)">
                <div matTooltip="{{specialMeal.LessonName | uppercase}}" matTooltipPosition="above"
                  class="p-1 dining-list-title text-truncate text-uppercase text-center dining-title">
                  {{specialMeal.LessonName}}
                </div>
                <div
                  class="p-1 text-uppercase text-center class-info__detail__location d-flex justify-content-center align-items-center">
                  <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                  &nbsp;<span class="text-truncate activity-description-bold">{{specialMeal.venueName}}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="diningSpecialMeals.length == 0">
        <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg: ('noSpecialMeal' | translate)}"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
</div>
<ng-template #noDataTemplate let-contentMsg="contentMsg" let-parameter = "parameter">
  <div
    class="col-sm-12 no-slots-message activity-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
    {{contentMsg | translate}}  {{parameter}}</div>
</ng-template>

<ng-template #actvitiesDisplayGridTemplate let-avlLessons="avlLessons">
  <div class="activity activity-card d-flex flex-column">
    <div class="activity-image cursor" (click)="getActivitiesDetails(avlLessons)">
      <img src="{{avlLessons.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'" />
    </div>
    <div class="activity-details col p-4 d-flex flex-column justify-content-between">
      <div matTooltip="{{avlLessons.LessonName | uppercase}}" class="text-uppercase text-truncate activity-title">{{avlLessons.LessonName}}</div>
      <div class="activity-description d-flex" *ngIf="avlLessons.BaseRate">
        {{'pricesStartsFrom' | translate}} <strong *ngIf="avlLessons.BaseRate" class="ms-3">
          {{avlLessons?.OperationCurrency}}{{avlLessons.BaseRate | currencyDecimalFormatter}}</strong>
        <strong *ngIf="!avlLessons.BaseRate">&ensp;{{'-'}}</strong>
      </div>
      <div>
        <div class="activity-description justify-content-center" *ngIf="avlLessons.TimeRemaining"><span *ngIf = "!avlLessons.Ongoing">{{'startsIn' | translate}}&ensp;</span><strong>{{avlLessons.TimeRemaining}}</strong></div>
        <div class="activity-description expired-label" *ngIf="!avlLessons.TimeRemaining">{{'expired' | translate}}</div>
        <!-- Uncomment to Show Sold Out in Future -->
        <!-- <div *ngIf="avlLessons.AvailableSlots === 0" class="activity-soldout-msg activity-description-bolder justify-content-center">{{'soldOut' | translate}}</div> -->
      </div>
      <div class="text-uppercase class-info__detail__location activity-title d-flex">
        <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
        &nbsp;<span class="text-truncate">{{avlLessons.venueName}}</span>
      </div>
      <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
       (click)="clickBookNow(avlLessons)">{{'bookNow' | translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #actvitiesDisplayListTemplate let-avlLessons="avlLessons">
  <div class="activity-list activity-card d-flex flex-row">
    <div *ngIf="activityService.ConfigSettings.showActivityImageInListView" class="activity-list-image cursor"
      (click)="getActivitiesDetails(avlLessons)">
      <img src="{{avlLessons.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'"/>
    </div>
    <div (click)="clickBookNow(avlLessons)" class="activity-details col p-4 d-flex flex-column justify-content-between">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="p-0 col-lg-7 col-md-7 col-12">
          <div class="pe-5 d-flex">
            <div matTooltip="{{avlLessons.LessonName | uppercase}}" class="text-uppercase activity-title activity-list-title text-truncate">{{avlLessons.LessonName}}</div>
            <mat-icon (click)="getActivitiesDetails(avlLessons);$event.stopPropagation();" class="ms-3 list-info-icon">info</mat-icon>
          </div>
        </div>
        <div class="p-0 col-lg-5 col-md-5 col-12">
          <div class="activity-description" *ngIf="avlLessons.TimeRemaining"><span *ngIf = "!avlLessons.Ongoing">{{'startsIn' | translate}}&ensp;</span><strong>{{avlLessons.TimeRemaining}}</strong></div>
          <div class="activity-description expired-label" *ngIf="!avlLessons.TimeRemaining">{{'expired' | translate}}</div>
          </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="p-0 col-lg-7 col-md-7 col-12 order-md-1 order-2">
          <div class="p-0 col-12 text-uppercase class-info__detail__location activity-title d-flex align-items-center">
            <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
            <div class="pe-5 text-truncate">{{avlLessons.venueName}}</div>
          </div>
        </div>
        <div class="p-0 col-lg-5 col-md-5 col-12 order-md-2 order-1 activity-description" *ngIf="avlLessons.BaseRate">          
          <div><span class="pe-2">{{'pricesStartsFrom' | translate}}</span>
            <strong class="ms-3" *ngIf="avlLessons.BaseRate">{{avlLessons?.OperationCurrency}}{{avlLessons.BaseRate | currencyDecimalFormatter}}</strong>
            <strong *ngIf="!avlLessons.BaseRate">{{'-'}}</strong>
          </div>
        </div>
      </div>
      <!-- <div class="activity-description d-flex flex-wrap justify-content-between">
        <div><span class="pe-3">Prices starts from</span>
          <strong *ngIf="avlLessons.BaseRate">{{avlLessons.BaseRate | currencyDecimalFormatter | currency}}</strong>
          <strong *ngIf="!avlLessons.BaseRate">{{'-'}}</strong>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between align-items-center">
        <div class="p-0 col-12 text-uppercase class-info__detail__location activity-title d-flex align-items-center">
          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
          {{avlLessons.venueName}}
        </div>
      </div> -->
      <div *ngIf="activityService.ConfigSettings.showBookButtonInListView"
        class="p-0 col-12 mt-3 mt-md-0 d-sm-flex justify-content-end" (click)="clickBookNow(avlLessons)">
        <div
          class="activity-book-button d-flex justify-content-center align-items-center activity-book-list-button activity-buttons text-center text-uppercase">
          {{'bookNow' | translate}}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #LessonsDetailsDialog>
  <mat-card class="lessons-details-dialog">
    <mat-card-header>
      <mat-card-title>{{'activitiesDetails' | translate }} 
        <mat-icon class="dialog-close float-right cursor-pointer material-icons-round" (click)="detailDialogClose()">
            close
        </mat-icon>
      </mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
      <div class="activity-image">
        <img src="{{selectedActivities?.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'"/>
      </div>
      <section class="class-info__detail" [ngClass]="{'mt-20':selectedActivities.ImageUrl === ''}">
        <div class="class-info__detail--header">
          <div class="class-info__detail--header-left">
            <h1 class="class-info__detail__name">{{selectedActivities.LessonName}}</h1>
            <div class="class-info__detail__location">
              <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
              &nbsp;{{selectedActivities.LocationName}}
            </div>
          </div>
          <div class="class-info__detail--header-right" *ngIf="selectedActivities.BaseRate">
            <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
            <div class="class-info__detail__rate-value">{{selectedActivities?.OperationCurrency}}
              {{selectedActivities.BaseRate | currencyDecimalFormatter}}
            </div>
          </div>
        </div>
        <div class="class-info__detail--content">
          <div class="class-info__detail__item">
            <label for="activity-type" class="class-info__detail__item--label">{{'activityType' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.activityType}}</div>
          </div>
          <div class="class-info__detail__item">
            <label for="start-date" class="class-info__detail__item--label">{{'startDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.StartDate | date:'MM/dd/yyyy'}}</div>
          </div>
          <div class="class-info__detail__item">
            <label for="endDate" class="class-info__detail__item--label">{{'endDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.EndDate | date:'MM/dd/yyyy'}}</div>
          </div>
          <div class="class-info__detail__item" *ngIf="showAvailableSlotCount">
            <label for="available" class="class-info__detail__item--label">{{'availableSlots' | translate}}</label>
            <i *ngIf="selectedActivities.ClassType === selectedActivities.Session"
              class="icon-Info class-info__detail__slotInfo" matTooltipPosition="above"
              matTooltip="{{ 'sessionSlotCountInfoMessage' | translate}}"></i>
            <div class="class-info__detail__item--value class-info__detail__item__value-avilable">
              {{selectedActivities.AvailableSlots}}
            </div>
          </div>
          <div class="class-info__detail__item class-info__detail__item_last">
            <label for="instructor" class="class-info__detail__item--label">{{'staff' | translate}}</label>
            <div class="class-info__detail__item--value class-info__ellipsis" title="{{selectedActivities.Staffs}}">
              {{selectedActivities.Staffs}}</div>
          </div>
        </div>
        <div *ngIf="!showAvailableSlotCount || selectedActivities.AvailableSlots === 0"
          class="class-info__detail__note">{{'checkAvailabilityOtherDays' |
          translate}}</div>
       
      </section>
      <section class="class-info__description" *ngIf="selectedActivities.Description">
        <h2 class="heading-secondary">
          {{'description' | translate}}
        </h2>
        <p class="class-info__description-text">
          {{selectedActivities.Description | textCutter: (descriptionReadMoreClicked ? null : textMaxLegth)}}
          <span class="class-info__read-more" *ngIf="selectedActivities.Description.length > textMaxLegth"
            (click)="descriptionReadMoreClicked = !descriptionReadMoreClicked">
            {{descriptionReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
          </span>
        </p>
      </section>
      <section class="class-info__description" *ngIf="selectedActivities.safetyInformation">
        <h2 class="heading-secondary">
          {{'safetyInformation' | translate}}
        </h2>
        <p class="class-info__description-text">
          {{selectedActivities.safetyInformation | textCutter: (safetyInformationReadMoreClicked ? null : textMaxLegth)}}
          <span class="class-info__read-more" *ngIf="selectedActivities?.safetyInformation.length > textMaxLegth"
            (click)="safetyInformationReadMoreClicked = !safetyInformationReadMoreClicked">
            {{safetyInformationReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
          </span>
        </p>
      </section>
      <section class="class-info__description" *ngIf="selectedActivities?.CancellationPolicy">
        <h2 class="heading-secondary">
          {{'CancellationPolicy' | translate}}
        </h2>
        <p class="class-info__description-text">
          {{selectedActivities?.CancellationPolicy | textCutter: (cancellationPolicyReadMoreCilcked ? null : textMaxLegth)}}
          <span class="class-info__read-more" *ngIf="selectedActivities?.CancellationPolicy.length > textMaxLegth"
            (click)="cancellationPolicyReadMoreCilcked = !cancellationPolicyReadMoreCilcked">
            {{cancellationPolicyReadMoreCilcked ? ('readLess' | translate) : ('readMore' | translate)}}
          </span>
        </p>
      </section>
      <section class="class-info__detail--footer">
        <div class="p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
          (click)="clickBookNow(selectedActivities);">{{'bookNow' | translate}}</div>
      </section>
    </mat-dialog-content>
  </mat-card>
</ng-template>
